import { useEffect } from 'react'
import { websocketClient } from '@/lib/websocket'
import { useUserQuery } from '@/domains/user/queries'

export const useWebsocket = () => {
  const { data: user } = useUserQuery()

  useEffect(() => {
    if (!user) return

    websocketClient.connect()

    return () => {
      websocketClient.disconnect()
    }
  }, [user?.user.id])
}
